import React from 'react';
import { Routes, Route } from 'react-router-dom';

import ResetPassword from './ResetPassword';
import AccessCode from './AccessCode';
import ForgotPassword from './ForgotPassword';
import Register from './Register';
import SignIn from './SignIn';
import SSOSignIn from './SSOSignIn';

const Login = () => {
	return (
		<Routes>
			<Route index element={<SignIn />} />
			<Route path="/forgot" element={<ForgotPassword />} />
			<Route path="/new" element={<Register />} />
			<Route path="/reset" element={<ResetPassword />} />
			<Route path="/access" element={<AccessCode />} />
			<Route path="/sso" element={<SSOSignIn />} />
		</Routes>
	);
};

export default Login;
